import { CreateAiInterviewerMutationVariables } from "../../../graphql";

/* ------------------------------------------------------------------ */
/*  Material input – polymorphic shape reused across all material      */
/*  categories (JD, rubric, scorecard, etc.)                           */
/* ------------------------------------------------------------------ */

export type MaterialInputMethod =
  | "type_or_paste"
  | "upload"
  | "add_link"
  | "brighthire"
  | "ats";

export type MaterialInput = {
  method: MaterialInputMethod | null;
  textValue: string;
  linkValue: string;
  /** Text extracted from a URL via ExtractTextFromUrl mutation. */
  linkExtractedText: string;
};

export const EMPTY_MATERIAL_INPUT: MaterialInput = {
  method: null,
  textValue: "",
  linkValue: "",
  linkExtractedText: "",
};

export function isMaterialInputComplete(input: MaterialInput): boolean {
  if (!input.method) return false;
  switch (input.method) {
    case "type_or_paste":
      return !!input.textValue.trim();
    case "add_link":
      return !!input.linkExtractedText.trim();
    case "upload":
    case "brighthire":
    case "ats":
      return false;
  }
}

export function materialInputToText(input: MaterialInput): string {
  if (!input.method) return "";
  switch (input.method) {
    case "type_or_paste":
      return input.textValue;
    case "add_link":
      return input.linkExtractedText;
    case "upload":
    case "brighthire":
    case "ats":
      return "";
  }
}

/* ------------------------------------------------------------------ */
/*  Flex Intake form values                                            */
/* ------------------------------------------------------------------ */

export type FlexIntakeFormValues = {
  name: string;
  displayName: string;
  positionId?: string;
  staticLinkEnabled?: boolean;
  autoCreateGuide: boolean;
  guideContext: string;
  jobDescription: MaterialInput;
};

export const FLEX_INTAKE_DEFAULT_VALUES: FlexIntakeFormValues = {
  name: "",
  displayName: "",
  positionId: "",
  staticLinkEnabled: false,
  autoCreateGuide: true,
  guideContext: "",
  jobDescription: { ...EMPTY_MATERIAL_INPUT },
};

/* ------------------------------------------------------------------ */
/*  Temporary adapter – bridges to the existing CreateAiInterviewer    */
/*  mutation until the dedicated flex-intake endpoint ships.            */
/* ------------------------------------------------------------------ */

export function toCreateAiInterviewerVars(
  values: FlexIntakeFormValues
): CreateAiInterviewerMutationVariables {
  return {
    name: values.name,
    displayName: values.displayName,
    jobDescription: materialInputToText(values.jobDescription),
    guideContext: values.autoCreateGuide ? values.guideContext || null : null,
    autoCreateGuide: values.autoCreateGuide,
    positionId: values.positionId || null,
    staticLinkEnabled: values.staticLinkEnabled,
  };
}
